import { render, staticRenderFns } from "./AddWidgetSidebar.vue?vue&type=template&id=3a7b2312&"
import script from "./AddWidgetSidebar.vue?vue&type=script&lang=js&"
export * from "./AddWidgetSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddWidgetSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports